export const experienceData = [
    // {
    //     id: 1,
    //     company: 'S.K. Engineering and Allied Works',
    //     jobtitle: 'Internship',
    //     startYear: '2018',
    //     endYear: '2018'
    // },
    // {
    //     id: 2,
    //     company: 'Byjus The Learning App',
    //     jobtitle: 'Business Development Associate',
    //     startYear: '2020',
    //     endYear: '2021'
    // },
    // {
    //     id: 3,
    //     company: '-',
    //     jobtitle: '-',
    //     startYear: '-',
    //     endYear: '-'
    // },
]